import React, { useEffect, useState } from "react";
import { Box, Button, Container, Typography, Paper, Grid, CardContent ,Card} from "@mui/material";
import { IconMailCheck } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import PageContainer from "./Pagecontainer";
// import Logo from '.././Images/logo1.png'
import Logo from '.././Images/logo-dark.png'

const EmailVerification = () => {
    const navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);
    const userid = params.get("userid");
    const Email = params.get("email")
    const Otp = params.get("otp")
    const [enablebutton, setEnableButton] = useState(false)
    const [error, seterror] = useState('')
    const [ShowSuccess, setShowSuccess] = useState(false)
    const Submit = async () => {
        let req = {
            otp: Otp,
            phone: Email,
            user_id: userid
        }
       let config = axios.defaults.headers.common = { 'Authorization': `` };
        try {
            const response = await axios.post("/apiV1/email-verify/", req, config)
            if (response.status == 200) {
                setShowSuccess(true)
            }

        }
        catch (err) {
            console.log(err);
            seterror(err.response.data.message)
        }
    }
    const resendOtp = async () => {
        try {
            let req = {
                phone: Email
            }
            const response = await axios.post(`/apiV1/resend-otp-email/`, req)
            console.log(response);
        } catch (err) {
            console.log(err);

        }
    }
    useEffect(() => {
        Submit()
    }, [])
    useEffect(() => {
        const timer = setTimeout(() => {
            setEnableButton(true);
        }, 6000);

        return () => clearTimeout(timer);
    }, []);
    return (
        <>
        <PageContainer title="SmartInvestorDeck | EmailVerification">
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={{ minHeight: "100vh", bgcolor: "#f5f5f5" }} 
            >
                <Grid item xs={12} sm={8} md={6} lg={5}>
                    <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
                        <CardContent>
                            <Box sx={{ textAlign: "center" }}>
                            <img src={Logo} alt="logo" style={{ width: "250px" ,marginBottom:20}} />
                                {ShowSuccess ? (
                                    <>
                                        <Typography variant="h5" fontWeight="bold">
                                            Email Verified Successfully!
                                        </Typography>
                                        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                                            <IconMailCheck size={60} color="#4CAF50" />
                                        </Box>
                                    </>
                                ) : (
                                    <Typography variant="h5" fontWeight="bold">
                                        Verify Your Email
                                    </Typography>
                                )}
                                <Typography variant="body1" color="textSecondary" sx={{ mt: 1, mb: 3 }}>
                                    {error}
                                </Typography>

                                {/* Buttons Section */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: 2,
                                        width: "100%",
                                        mt: 2,
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        sx={{ width: "250px" }}
                                        onClick={() => navigate("/")}
                                    >
                                        Go to Login
                                    </Button>
                                    {/* <Button
                                        variant="outlined"
                                        color="secondary"
                                        sx={{ width: "250px" }}
                                        onClick={resendOtp}
                                        disabled={!enablebutton}
                                    >
                                        Resend Link
                                    </Button> */}
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            </PageContainer>
        </>
    )
};

export default EmailVerification;
